import { mapActions } from "vuex";
export default {
    data() {
        return {
            levelList: [{ rootId: "", rootName: this.$t("lang.全部") }],
            levelEmpty: [{ rootId: "", rootName: this.$t("lang.全部") }],
        }
    },
    created() {
        this.iRootSimpleList();
    },
    methods: {
        ...mapActions({
            rootSimpleList: "ZD_RootSimpleList",
        }),
        /**获取层级列表 */
        async iRootSimpleList() {
            try {
                let res = await this.rootSimpleList({});
                if (res.success !== 1 || this.isnull(res.listitem)) throw new Error("");
                res.listitem.unshift({ rootId: "", rootName: this.$t("lang.全部") });
                this.levelList = res.listitem;
            } catch (e) {
                this.levelList = this.docopy(this.levelEmpty);
            }
        },
    },
}